import React, { useState } from "react";
import { X, Play, Pause, Check, ShoppingCart, MessageCircle } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function SongListSheet({ open, onClose }) {
  const { artist, current, playing, playSong, ownsSong, requestBuy } = useApp();
  const [query, setQuery] = useState("");

  if (!open) return null;

  const songs = artist.songs.filter((s) =>
    s.title.toLowerCase().includes(query.toLowerCase())
  );

  const handleBuy = (song) => requestBuy(song);

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 w-full max-w-[480px] max-h-[82vh] rounded-t-3xl bg-[#0e0e10] border-t border-white/10 flex flex-col">
        <div className="flex items-center justify-between px-5 pt-4 pb-3">
          <div className="flex items-center gap-2">
            <span className="section-dot bg-[#8b5cf6]" />
            <h3 className="text-[13px] font-semibold tracking-[0.16em] uppercase">All Singles</h3>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10">
            <X size={16} />
          </button>
        </div>

        <div className="px-5 pb-3">
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search songs..."
            className="w-full px-4 h-10 rounded-full bg-white/[0.06] border border-white/10 outline-none text-[14px] placeholder:text-white/35"
          />
        </div>

        <div className="overflow-y-auto px-3 pb-8">
          {songs.map((song) => {
            const isCurrent = current && current.id === song.id;
            const isPlaying = isCurrent && playing;
            const owned = ownsSong(song.id);
            return (
              <div key={song.id} className="flex items-center gap-3 px-2 py-2.5 rounded-xl hover:bg-white/[0.04]">
                <div className="relative w-12 h-12 rounded-lg overflow-hidden shrink-0">
                  <img src={song.cover} alt={song.title} className="w-full h-full object-cover" />
                  <button onClick={() => playSong(song)} className="absolute inset-0 flex items-center justify-center bg-black/35 opacity-0 hover:opacity-100 transition-opacity">
                    {isPlaying ? <Pause size={16} /> : <Play size={16} />}
                  </button>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[10px] tracking-[0.14em] uppercase text-white/35">{song.label}</p>
                  <p className="text-[14px] font-medium text-white truncate">{song.title}</p>
                  <p className="text-[11px] text-white/40">{song.plays} plays</p>
                </div>
                <button className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center text-white/50 hover:text-white hover:bg-white/10">
                  <MessageCircle size={15} />
                </button>
                {owned ? (
                  <span className="flex items-center gap-1 text-[11px] text-[#8b5cf6] font-semibold w-[64px] justify-center">
                    <Check size={13} /> Owned
                  </span>
                ) : (
                  <button
                    onClick={() => handleBuy(song)}
                    className="flex items-center gap-1 text-[12px] font-semibold px-3 h-9 rounded-full bg-white text-black hover:bg-white/85 transition-colors w-[64px] justify-center"
                  >
                    ${song.price.toFixed(2)}
                  </button>
                )}
              </div>
            );
          })}
          {songs.length === 0 && (
            <p className="text-center text-sm text-white/40 py-10">No songs found.</p>
          )}
        </div>
      </div>
    </div>
  );
}
